module.exports = __webpack_public_path__ + "img/img1.713e3771.jpg";